import type { UploadUrlResponse } from '../types';

export const buildBlobUploadUrl = (upload: UploadUrlResponse) => {
  const segments = [upload.baseUrl.replace(/\/$/, '')];
  if (upload.folder) {
    segments.push(
      upload.folder
        .split('/')
        .map((segment) => encodeURIComponent(segment))
        .join('/')
    );
  }
  segments.push(encodeURIComponent(upload.filename));
  const path = segments.join('/');
  if (!upload.sasToken) {
    return path;
  }
  const token = upload.sasToken.startsWith('?') ? upload.sasToken : `?${upload.sasToken}`;
  return `${path}${token}`;
};